import { IsoDate, QueryFilter, Range } from '@softline/core';
import { FilterState, readDateRangeFilter } from '@softapps/core/filter';
import { AbcAnalysisFilterRow } from '../types/abc-analysis-filter-row';

export function abcAnalysisDefaultPeriod(): Range<IsoDate> {
  const now = new Date();
  return {
    from: `${now.getFullYear()}-01-01` as IsoDate,
    to: now.toISOString().slice(0, 10) as IsoDate,
  };
}

/** The period the filter holds; the configured initial one when the user removed the chip or an old template cleared it. */
export function abcAnalysisPeriod(state: FilterState<AbcAnalysisFilterRow>): Range<IsoDate> {
  return (
    readDateRangeFilter(state.state(), 'period')?.range ??
    readDateRangeFilter(state.config.initialValue, 'period')?.range ??
    abcAnalysisDefaultPeriod()
  );
}

export function abcAnalysisPeriodQueryFilter<T extends object>(state: FilterState<AbcAnalysisFilterRow>): QueryFilter<T> {
  const period = abcAnalysisPeriod(state);
  return { type: 'dateInRange', name: 'period', valueFrom: period.from, valueTo: period.to } as unknown as QueryFilter<T>;
}

/** queryFilter() with the period guaranteed: the backend must never see an unbounded abc query. */
export function abcAnalysisQueryFilter<T extends object>(state: FilterState<AbcAnalysisFilterRow>): QueryFilter<T> {
  const filter = state.queryFilter() as unknown as QueryFilter<T> | null;
  if (readDateRangeFilter(state.state(), 'period')) return filter as QueryFilter<T>;
  const period = abcAnalysisPeriodQueryFilter<T>(state);
  return filter ? ({ type: 'conditions', operator: 'AND', filters: [filter, period] } as unknown as QueryFilter<T>) : period;
}
